import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { SpaceService } from './../../../../../services/space.service';
import { MemberService } from './../../../../../rest/api/member.service';
import { AuthService } from './../../../../../services/auth.service';
import { PaymentService as PaymentLocalService } from '../../../../../services/payment/payment.service';
import { HelperService } from './../../../../../services/helper.service';

import * as _ from 'lodash';
@Component({
  selector: 'app-confirmdollhouse',
  templateUrl: './confirmdollhouse.component.html',
  styleUrls: ['./confirmdollhouse.component.scss']
})
export class ConfirmdollhouseComponent implements OnInit {
  isSubmitting = false;
  isSubmitted = false;
  spaceData: any;
  accessToken: any;

  processingFeePlan: any;
  taxPercentage = 0;
  loader = true;

  cardData: any;
  cardLoader = true;

  // Payment form
  createPaymentFormSubmitted = false;
  createPaymentForm: FormGroup;
  ccvCodeRegex = '^[0-9]{3,4}$';

  errors = [];
  successMsg: string;
  errorMsg: string;

  constructor(
    public spaceService: SpaceService,
    public fb: FormBuilder,
    public router: Router,
    private authService: AuthService,
    public memberService: MemberService,
    public paymentLocalService: PaymentLocalService,
    public helperService: HelperService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.spaceService.spaceDataSubscription.subscribe(response => {
      if (Object.keys(response).length === 0 && response.constructor === Object) {
        this.router.navigate(['/member']);
      }
      if (response) {
        this.spaceData = response;
        this.getPlans();
        this.getPaymentCard();
        this.createPaymentFormInit();
      }
    });
  }

  getPlans() {
    this.paymentLocalService.planDataSubscription.subscribe(response => {
      if (response) {
        const plansData = response;
        this.processingFeePlan  = _.find(plansData, {plan_type: 'processing_fee' }) ? _.find(plansData, {plan_type: 'processing_fee' }) : false;
        if (this.processingFeePlan && this.processingFeePlan.tax) {
          this.taxPercentage = this.processingFeePlan.tax;
        }
        this.loader = false;
      }
    });
  }

  getPaymentCard() {
    this.memberService.getPaymentCard(this.accessToken).subscribe((response: any) => {
      const cardsList = response && response.data ? response.data : [];
      this.cardData = _.find(cardsList, {DefaultFlag: '1'});
      this.cardLoader = false;
    }, err => {
      this.cardLoader = false;
    });
  }

  seperateDateFormat(carddate) {
    const splitted = carddate.match(/(.{1,2})/g);
    return splitted[0] && splitted[1] ? splitted[1] + '/' + splitted[0] : '-';
  }

  // Payment form cvv
  createPaymentFormInit() {
    this.createPaymentForm = this.fb.group({
      ccvCode: ['', [Validators.required, Validators.pattern(this.ccvCodeRegex)] ],
    });
  }

  submitForm(value) {
    if (!this.createPaymentForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    const data = this.createPaymentForm.value;
    data.space_id = this.spaceData.uuid;
    data.cvv = this.createPaymentForm.value.ccvCode;
    data.amount = this.getTotalPrice();
    this.requestNewDollhouse(data);
  }

  requestNewDollhouse(data) {
    const thisobject = this;
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.requestNewDollhouse({
      Authorization: this.accessToken,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Your request for dollhouse has been submitted!';
      // this.scrollHelper.scrollToFirst('alert-success');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setTimeout(() => {
        window.location.href = `member/spaces/${thisobject.spaceData.uuid}/showcase`;
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.resetFormValues();
  }

  resetFormValues() {
    this.createPaymentForm.reset({
      ccvCode: ''
    });
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while processing.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  getSubTotalPrice() {
    const subsriptionPrice = this.processingFeePlan && this.processingFeePlan.new_price ? this.processingFeePlan.new_price : 0;
    return subsriptionPrice;
  }

  getTaxAmount() {
    if (this.taxPercentage && this.taxPercentage > 0) {
      const subTotalPrice = this.getSubTotalPrice();
      const taxAmount = subTotalPrice * this.taxPercentage / 100;
      return Math.round(taxAmount);
    }
    return 0;
  }

  getTotalPrice() {
    return this.getSubTotalPrice() + this.getTaxAmount();
  }

}
